import React, { useEffect, useState } from 'react'
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container'
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container'
import { FaCamera, FaTimes, FaVideo } from 'react-icons/fa'
import { HiOutlineTrash } from 'react-icons/hi'
import { CollectionModalComponet } from '../../../../../models/collection-modal'
import UploadFilesContainer from '../../../../../models/upload-url-file'
import BrandMappingContainer from '../../../card-types/containers/brand-mapping'
import TemplateContainer from '../../../card-types/containers/template'
import SocialProfileContainer from '../../../card-types/containers/social-profile'
import AnnouncementContainer from '../../../card-types/containers/announcement'
import BlogPostContainer from '../../../card-types/containers/blog-post'
import HelpTopicContainer from '../../../card-types/containers/help-topic'

export default function AddLayoutCardComponent({ handleCloseProductModal,isModalProductOpen,handleCloseModal,isModalOpen,handleOpenModal,handleOpenProductModal,additionButtons,onSelect,categoriesPaginationData,setPageData,categoryColumnDefs,productsPaginationData,productColumnDefs,categories,products,changeCardFile,handleInnerFormChange,deletewebPageCardItem,typeData,cardTypes,handleFormChange,webPageCards,Id,cardValues}: any) {
  useEffect(() => {
    if (!webPageCards.CardTypeId) {
      handleInnerFormChange(10, 'CardTypeId');
    }
  }, []);
  const [isModalMediaOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const [imageUrls, setImageUrls] = useState<string[]>([]); // Array to store multiple URLs
  // Function to handle URL save
  const handleSaveUrls = (urls: string[]) => {
    setImageUrls(urls); // Set the new array of URLs
    webPageCards.cardDetailInfo =urls.map((url, index) => ({
        Id: 0,
        OwnerTypeId: 0,
        OwnerId: 0,
        FileTypeId:10,
        Name: "string",
        Description: "string",
        FileMappingURL: url,
        IsApproved: true
    }))
    closeModal(); // Close the modal after saving URLs
  };


  const [isBrandMappingModalOpen, setBrandMappingModalOpen] = useState(false);
  const openBrandMappingModal = () => {
    setBrandMappingModalOpen(true);
  };
  const closeBrandMappingModal = () => {
    setBrandMappingModalOpen(false);
  };
  const handleBrandMappingsSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo = mappings,
    closeBrandMappingModal()
  };


  const [isTemplateModalOpen, setTemplateModalOpen] = useState(false);
  const openTemplateModal = () => {
    setTemplateModalOpen(true);
  };

  const closeTemplateModal = () => {
    setTemplateModalOpen(false);
  };
  const handleTemplatesSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeTemplateModal()
  };


  
  const [isSocialProfileModalOpen, setSocialProfileModalOpen] = useState(false);
  const openSocialProfileModal = () => {
    setSocialProfileModalOpen(true);
  };

  const closeSocialProfileModal = () => {
    setSocialProfileModalOpen(false);
  };
  const handleSocialProfilesSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeSocialProfileModal()
  };


  const [isAnnouncementModalOpen, setAnnouncementModalOpen] = useState(false);
  const openAnnouncementModal = () => {
    setAnnouncementModalOpen(true);
  };

  const closeAnnouncementModal = () => {
    setAnnouncementModalOpen(false);
  };
  const handleAnnouncementSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeAnnouncementModal()
  };
  const [isHelpTopicModalOpen, setHelpTopicModalOpen] = useState(false);
  const openHelpTopicModal = () => {
    setHelpTopicModalOpen(true);
  };

  const closeHelpTopicModal = () => {
    setHelpTopicModalOpen(false);
  };
  const handleHelpTopicSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeHelpTopicModal()
  };


  const [isBlogModalOpen, setBlogModalOpen] = useState(false);
  const openBlogModal = () => {
    setBlogModalOpen(true);
  };

  const closeBlogModal = () => {
    setBlogModalOpen(false);
  };
  const handleBlogSubmit = (mappings: any) => {
    webPageCards.cardDetailInfo= mappings;
    closeBlogModal()
  };
  const isDisabled = cardValues.some((cardData: any) => cardData?.type === 'product' || cardData?.type === 'category');
  return (
    <>   
      <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
          label="Card Name"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'CardName',
            )
          }}
          rows={4}
          type="text"
          value={webPageCards?.CardName}
        />
        <InputContainer
          label="Card Type"
          labelField="Text"
          list={cardTypes}
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'CardTypeId',
            )
          }}
          optionName='Choose Card Type'
          type="select"
          value={webPageCards.CardTypeId || 10}
          valueField="Value"
        />
      {webPageCards.CardTypeId && webPageCards.CardTypeId === 20 && (
        
           
        <button 
        onClick={openBrandMappingModal} 
        className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
        Create Brand Mapping
      </button>
         
        )}

 
 {webPageCards.CardTypeId && webPageCards.CardTypeId === 30 && (     
            <button 
              onClick={openTemplateModal} 
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
              Create Template Mapping
            </button>
        
        )}

{webPageCards.CardTypeId && webPageCards.CardTypeId === 50 && (
       
           
            <button 
              onClick={openSocialProfileModal} 
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
              Create Social Profile
            </button>
       
        )}

{webPageCards.CardTypeId && webPageCards.CardTypeId === 60 && (
       
           
       <button 
         onClick={openAnnouncementModal} 
         className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
         Create Announcement
       </button>
  
   )}

{webPageCards.CardTypeId && webPageCards.CardTypeId === 70 && (
       
           
       <button 
         onClick={openBlogModal} 
         className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
         Create Blog Post
       </button>
  
   )}
   {webPageCards.CardTypeId === 40 && (
        <div className="flex items-center space-x-4">
          {imageUrls.map((url, index) => (
            <img key={index} src={url} alt="Uploaded" className="w-12 h-12" />
          ))}
          <FaCamera className="cursor-pointer" onClick={openModal} />
        </div>
      )}
  {webPageCards.CardTypeId === 80 && (
        <button
        onClick={handleOpenModal}
        type='button'
        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
      >
       Categories on Top Menu
      </button>

      )}

{webPageCards.CardTypeId && webPageCards.CardTypeId === 90 && (
       
           
       <button 
         onClick={openHelpTopicModal} 
         className="m-2 bg-blue-700 text-white rounded font-medium px-4 h-12 mt-6">
         Create Help Topics
       </button>
  
   )}
      </div>
      {webPageCards.CardTypeId === 10 &&
      <div className="overflow-x-auto">
        <table className="table-auto w-full">
          <thead>
            <tr>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Field</th>
              <th className="px-4 py-2">Value</th>
              <th className="px-4 py-2">Delete</th>
            </tr>
          </thead>
          <tbody>
            {cardValues.map((cardData: any, index: any) => (
              <tr key={index}>
                <td className="px-4 py-2">
                  <InputContainer
                    labelField="text"
                    list={typeData}
                    onValueChange={(event: any) => {
                      handleFormChange({
                        value: event.target.value,
                        field: 'type',
                        idx: index
                      })
                    }}
                    optionName='Choose Field Type'
                    type="select"
                    value={cardData.type}
                    valueField="value"
                    isDisabled={isDisabled}
                  />
                </td>
                <td className="px-4 py-2">
                  <InputContainer
                    onValueChange={(event: any) => {
                      handleFormChange({
                        value: event.target.value,
                        field: 'field',
                        idx: index
                      })
                    }}
                    rows={4}
                    type="text"
                    value={cardData.field}
                    isDisabled={isDisabled}
                  />
                </td>
                <td className="px-4 py-2">
                  {cardData.type === 'text' && (
                    <InputContainer
                      onValueChange={(event: any) => {
                        handleFormChange({
                          value: event.target.value,
                          field: 'value',
                          idx: index
                        })
                      }}
                      rows={4}
                      type="text"
                      value={cardData.value}
                      isDisabled={isDisabled}
                    />
                  )}
                  {cardData.type === 'rte' && (
                    <InputContainer
                      onValueChange={(event: any) => {
                        handleFormChange({
                          value: event,
                          field: 'value',
                          idx: index
                        })
                      }}
                      type="rte"
                      value={cardData?.value}
                      isDisabled={isDisabled}
                    />
                  )}
                  {cardData.type === 'email' && (
                    <InputContainer
                      onValueChange={(event: any) => {
                        handleFormChange({
                          value: event.target.value,
                          field: 'value',
                          idx: index
                        })
                      }}
                      rows={4}
                      type="email"
                      value={cardData.value}
                      isDisabled={isDisabled}
                    />
                  )}
                  {cardData.type === 'number' && (
                    <InputContainer
                      onValueChange={(event: any) => {
                        handleFormChange({
                          value: event.target.value,
                          field: 'value',
                          idx: index
                        })
                      }}
                      rows={4}
                      type="number"
                      value={cardData.value}
                      isDisabled={isDisabled}
                    />
                  )}
                  {cardData.type === 'checkbox' && (
                    <InputContainer
                      onValueChange={(event: any) => {
                        handleFormChange({
                          value: event,
                          field: 'value',
                          idx: index
                        })
                      }}
                      rows={4}
                      type="checkbox"
                      value={cardData.value}
                      isDisabled={isDisabled}
                    />
                  )}
                  {cardData.type === 'image' && (
                    <>
                      <div onClick={() => !isDisabled && changeCardFile(index, 'value', 'image')}> 
                        <img
                          src={cardData.value}
                          className="w-12 h-12"
                        />
                        <FaCamera className="ml-4" />
                      </div>
                    </>
                  )}
                  {cardData.type === 'video' && (
                    <>
                      <div onClick={() => !isDisabled && changeCardFile(index, 'value', 'video')}> 
                        <video
                          src={cardData.value}
                          className="w-12 h-12"
                        />
                        <FaVideo className="ml-4" />
                      </div>
                    </>
                  )}
                  {cardData.type === 'product' && (
                    <button
                      onClick={handleOpenProductModal}
                      type='button'
                      className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                    >
                      Add Products 
                    </button>
                  )}
                  {cardData.type === 'category' && (
                    <button
                      onClick={handleOpenModal}
                      type='button'
                      className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                    >
                      Add Categories
                    </button>
                  )}
                </td>
                <td key={9} className="flex px-5 w-max flex-row justify-start item-baseline cursor-pointer pt-6 space-x-2">
                  <button className="text-red-500 hover:text-red-700" onClick={async () => deletewebPageCardItem(cardData, index)} disabled={isDisabled}>
                    <HiOutlineTrash className="w-6 h-6" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>}
      {/* <CollectionModalComponet
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        categoryColumnData={categoryColumnDefs}
        categoryRowData={categories}
        setPageData={setPageData}
        categoriesPaginationData={categoriesPaginationData}
        onSelect={onSelect}
        additionButtons={additionButtons}
        productColumnData={productColumnDefs}
        productRowData={products}
        productsPaginationData={productsPaginationData}
        isModalProductOpen={isModalProductOpen}
        handleCloseProductModal={handleCloseProductModal}
      /> */}
        {isModalMediaOpen &&
        <div className="fixed inset-0 ml-80 mt-40 flex w-[1000px] h-[400px] items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg w-full  overflow-y-auto">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold mb-4">Add URL</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <FaTimes className="w-6 h-6" />
              </button>
            </div>
            <UploadFilesContainer onSave={handleSaveUrls} />
            
      
      </div></div>
      }

{isBrandMappingModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Brand Mapping</h2>
        <button onClick={closeBrandMappingModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <BrandMappingContainer onSubmit={handleBrandMappingsSubmit} />
      </div>
    </div>
  </div>
)}


{isTemplateModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Templates</h2>
        <button onClick={closeTemplateModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <TemplateContainer onSubmit={handleTemplatesSubmit} />
      </div>
    </div>
  </div>
)}

{isSocialProfileModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Social Profiles</h2>
        <button onClick={closeSocialProfileModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <SocialProfileContainer onSubmit={handleSocialProfilesSubmit} />
      </div>
    </div>
  </div>
)}


{isAnnouncementModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl overflow-y-auto overflow-x-auto max-h-[80vh] ml-16">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Announcements</h2>
        <button onClick={closeAnnouncementModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]">
        <AnnouncementContainer onSubmit={handleAnnouncementSubmit} />
      </div>
    </div>
  </div>
)}

{isBlogModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-[60%] overflow-y-auto overflow-x-auto max-h-[80vh]"> {/* Reduced width to 50% */}
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Blog Posts</h2>
        <button onClick={closeBlogModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]"> 
        <BlogPostContainer onSubmit={handleBlogSubmit} />
      </div>
    </div>
  </div>
)}
{isHelpTopicModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-[60%] overflow-y-auto overflow-x-auto max-h-[80vh]"> {/* Reduced width to 50% */}
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Help Topics</h2>
        <button onClick={closeHelpTopicModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto overflow-x-auto max-h-[60vh]"> 
        <HelpTopicContainer onSubmit={handleHelpTopicSubmit} />
      </div>
    </div>
  </div>
)}

{handleOpenModal && (
      <CollectionModalComponet
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        categoryColumnData={categoryColumnDefs}
        categoryRowData={categories}
        setPageData={setPageData}
        categoriesPaginationData={categoriesPaginationData}
        onSelect={onSelect}
        additionButtons={additionButtons}
      />  
)}
    </>
  )
}